////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const articleLifeManager = {
	[ActionsTypes.RESET_DATA_ARTICLE_LIFE]: (state) => {
		return update(state, {
			articleLifeManager: {
				item: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_ARTICLE_LIFE_TIMELINE]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				timelineData: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_SUCCESS]: (state, payload) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				timelineData: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_PHASES]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				timelineLegend: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_PHASES_SUCCESS]: (state, payload) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				timelineLegend: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_PHASES_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.GET_HEADER_ACTION_ARTICLE_LIFE]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				header: {
					$set: {},
				},
			},
		})
	},

	[ActionsTypes.GET_HEADER_ACTION_ARTICLE_LIFE_SUCCESS]: (state, payload) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				header: {
					$set: payload,
				},
			},
		})
	},

	[ActionsTypes.GET_HEADER_ACTION_ARTICLE_LIFE_FAILURE]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		})
	},

	[ActionsTypes.POST_DELETED_ITEM]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.POST_DELETED_ITEM_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.POST_DELETED_ITEM_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_UNACTIVE_ITEM]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_UNACTIVE_ITEM_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_UNACTIVE_ITEM_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.POST_DELETE_STOP_DEPOSIT]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_DELETE_STOP_DEPOSIT_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_DELETE_STOP_DEPOSIT_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),

	[ActionsTypes.POST_ACTIVED_ITEM]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_ACTIVED_ITEM_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_ACTIVED_ITEM_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.UPDATE_START_DEPOSIT_ACTION]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_START_DEPOSIT_ACTION_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_START_DEPOSIT_ACTION_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.UPDATE_STOP_DEPOSIT_ACTION]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_STOP_DEPOSIT_ACTION_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_STOP_DEPOSIT_ACTION_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_ADD_STOP_DEPOSIT]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_ADD_STOP_DEPOSIT_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_ADD_STOP_DEPOSIT_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_DELETE_ADD_START_WITH_DEPOSIT]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_DELETE_ADD_START_WITH_DEPOSIT_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_DELETE_ADD_START_WITH_DEPOSIT_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_DELETE_SCHEDULED_ACTIVATE]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_DELETE_SCHEDULED_ACTIVATE_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_DELETE_SCHEDULED_ACTIVATE_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_ADD_START_WITH_DEPOSIT]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_ADD_START_WITH_DEPOSIT_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_ADD_START_WITH_DEPOSIT_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_SCHEDULE_ACTIVATE_ACTION]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_SCHEDULE_ACTIVATE_ACTION_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_SCHEDULE_ACTIVATE_ACTION_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.UPDATE_SCHEDULED_ACTIVATE_ACTION]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_SCHEDULED_ACTIVATE_ACTION_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_SCHEDULED_ACTIVATE_ACTION_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_SCHEDULED_DEACTIVATE_ACTION]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_SCHEDULED_DEACTIVATE_ACTION_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_SCHEDULED_DEACTIVATE_ACTION_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_CANCEL_DEACTIVATE_ACTION]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_CANCEL_DEACTIVATE_ACTION_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_CANCEL_DEACTIVATE_ACTION_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_DELETE_DESACTIVATION_SCHEDULED]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_DELETE_DESACTIVATION_SCHEDULED_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_DELETE_DESACTIVATION_SCHEDULED_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_DELETE_STOP_WITH_RESTOCK]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_DELETE_STOP_WITH_RESTOCK_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_DELETE_STOP_WITH_RESTOCK_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_ADD_STOP_WITH_RESTOCK]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_ADD_STOP_WITH_RESTOCK_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_ADD_STOP_WITH_RESTOCK_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_EDIT_STOP_WITH_RESTOCK]: (state) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: true,
				},
				isUpdate: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_EDIT_STOP_WITH_RESTOCK_SUCCESS]: (state) => {
		return update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				isUpdate: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_EDIT_STOP_WITH_RESTOCK_FAILURE]: (state, payload) =>
		update(state, {
			articleLifeManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
}

export default articleLifeManager
